<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        消息管理
      </div>
    </div>

    <el-form
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="接收终端">
        <el-select v-model="recType" placeholder="全部">
          <el-option label="总平台" value="0"></el-option>
          <el-option label="微信用户" value="1"></el-option>

          <el-option label="回收站" value="2"></el-option>
          <el-option label="仓库" value="3"></el-option>
          <el-option label="运营" value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="输入搜索">
        <el-input v-model="title" placeholder="请输入消息标题关键字"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchonzi">重置</el-button>
      </el-form-item>
    </el-form>

    <btns @exec="exec"></btns>

    <div class="x"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      @selection-change="tableSelectionChange"
    >
      <el-table-column type="selection" width="80"> </el-table-column>

      <el-table-column label="发送人" prop="nickName"> </el-table-column>

      <el-table-column label="接收终端" prop="recType">
        <template slot-scope="scope">
          <div v-if="scope.row.recType == 0">总平台</div>
          <div v-if="scope.row.recType == 1">微信用户</div>
          <div v-if="scope.row.recType == 2">回收站</div>
          <div v-if="scope.row.recType == 3">仓库</div>
          <div v-if="scope.row.recType == 4">运营</div>
        </template>
      </el-table-column>

      <el-table-column label="主体类型">
        <template slot-scope="scope">
          <div v-if="scope.row.createType == 0">总平台</div>
          <div v-if="scope.row.createType == 2">
            {{ scope.row.cname2 }}
          </div>
          <div v-if="scope.row.createType == 3">
            {{ scope.row.cname1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="接收主体数">
        <template slot-scope="scope">
          <div v-if="scope.row.recType == 0">总平台</div>
          <div v-if="scope.row.recType == 1">微信用户</div>
          <div v-if="scope.row.recType == 2">
            回收站：{{ scope.row.rname3 }}
          </div>
          <div v-if="scope.row.recType == 3">{{ scope.row.rname1 }}</div>
          <div v-if="scope.row.recType == 4">{{ scope.row.rname2 }}</div>
        </template>
      </el-table-column>

      <el-table-column label="消息标题" prop="title"> </el-table-column>

      <el-table-column label="发送时间" prop="createTime"> </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getchakxq(scope.row.messageId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>

    <el-dialog
      title="新增消息"
      :visible.sync="addORUpdateVisible"
      width="750px"
    >
      <el-form label-width="100px">
        <el-form-item label="选择接收主体">
          <el-radio-group v-model="addForm.recType" @change="getadd">
            <el-radio :label="0">仓库</el-radio>
            <el-radio :label="1">回收站</el-radio>
            <el-radio :label="2">所有主体</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="选择主体类型">
          <el-radio-group v-model="radio" @change="getzhiding">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">指定</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="shon">
          <el-form-item label="选择城市区域">
            <el-col :span="10">
              <el-input
                placeholder="请输入主体关键字搜索"
                v-model="subject"
                class="input-with-select"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-col>
          </el-form-item>

          <el-transfer
            :titles="['请选择', '已选择']"
            filterable
            filter-placeholder="请输入按钮名称"
            :props="{ key: 'backStopId', label: 'stopName' }"
            v-model="backStopId"
            :data="backstopList"
          ></el-transfer>
        </div>

        <div v-if="shisn">
          <el-form-item label="选择城市区域">
            <el-col :span="10">
              <el-input
                placeholder="请输入主体关键字搜索"
                v-model="subject"
                class="input-with-select"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </el-col>
          </el-form-item>

          <el-transfer
            :titles="['请选择', '已选择']"
            filterable
            filter-placeholder="请输入按钮名称"
            :props="{ key: 'houseId', label: 'houseName' }"
            v-model="backStopId"
            :data="backstopList"
          ></el-transfer>
        </div>

        <el-form-item label="消息标题">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="addForm.text"
            maxlength="20"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="消息内容">
          <edit v-model="addForm.info"></edit>
        </el-form-item>

        <el-form-item class="mgt-100">
          <el-button type="primary" @click="getlijicj">立即创建</el-button>
          <el-button>重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import btns from "@/components/btns.vue";
import edit from "@/components/edit.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    edit,
    breadcrumbs,
  },
  data() {
    return {
      backstopList: [],

      backStopId: [],
      shisn: false,
      shon: false,

      subject: "",
      btac: "",
      houseName: "",
      text: "",
      addForm: {
        recType: "",

        text: "",

        title: "",
        info: "",
      },
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      tableSelection: [],
      recType: "",
      title: "",
      addORUpdateVisible: false,
      radio: 0,
      tableData: [],
      searchForm: { name: "" },

      // data: generateData(),
      // value: [],
      // filterMethod(query, item) {
      //   return item.pinyin.indexOf(query) > -1;
      // },
    };
  },
  //   data() {
  //     return {
  //       addORUpdateVisible: false,
  //       radio: 3,
  //       tableData: [{ planCount: "你好" }],
  //       searchForm: { name: "" },
  //     };
  //   },

  created() {
    this.getSendMessageList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    getlijicj() {
      var a = this.backStopId.join(",");

      this.$api.activitymsg
        .sendMessage({
          title: this.addForm.text,

          recType: this.radio,

          recIds: a,

          content: this.addForm.info,
        })
        .then((d) => {
          if (d.code == 200) {
            this.$message({
              message: "增加成功",
              type: "success",
            });
            this.addORUpdateVisible = false;
            this.getSendMessageList(
              this.searlist.curPage,
              this.searlist.pageSize
            );
          } else {
            this.$message.error(d.msg);
          }
        });

      console.log(this.backStopId);
    },

    getzhiding() {
      if (this.addForm.recType == 1) {
        if (this.radio == 2) {
          this.shon = true;
          this.backStopId = [];
        } else {
          this.backstopList.map((item) => {
            this.backStopId.push(item.backStopId);
          });

          this.shon = false;
        }
      } else if (this.addForm.recType == 0) {
        if (this.radio == 2) {
          this.backStopId = [];
          this.shisn = true;
        } else {
          this.shisn = false;
          this.backstopList.map((item) => {
            this.backStopId.push(item.houseId);
          });
        }
      } else {
        this.shisn = false;
        this.shon = false;
      }
    },

    getadd() {
      if (this.addForm.recType == 0) {
        this.$api.activitymsg
          .getOperateHouseList({
            current: 1,
            size: 100,
            houseName: this.houseName,
          })
          .then((e) => {
            this.backstopList = e.data;
            if (this.radio == 2) {
              this.backStopId = [];
              this.shon = true;
            } else {
              this.backstopList.map((item) => {
                this.backStopId.push(item.houseId);
              });
              this.shon = false;
            }
          });
      } else if (this.addForm.recType == 1) {
        this.$api.activitymsg
          .getBackStopList({
            current: 1,
            size: 100,
            keyword: this.keyword,
          })
          .then((e) => {
            this.backstopList = e.data;
            if (this.radio == 2) {
              this.backStopId = [];
              this.shisn = true;
            } else {
              this.backstopList.map((item) => {
                this.backStopId.push(item.backStopId);
              });
              this.shisn = false;
            }
          });
      } else {
        this.shisn = false;
        this.shon = false;
      }

      console.log(this.addForm.recType);
    },

    add() {
      this.addORUpdateVisible = true;
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getSendMessageList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getSendMessageList(v, this.searlist.pageSize);
    },

    tableSelectionChange(val) {
      this.tableSelection = val;
    },

    //删除数据
    del() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      // console.log(this.ta);
      this.$confirm("确认要删除该消息, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.activitymsg
            .batchDel({
              messageRecIds: this.tableSelection[0].messageId,
            })
            .then((d) => {
              if (d.code == 200) {
                this.$message.success("删除成功");
                this.getSendMessageList(
                  this.searlist.curPage,
                  this.searlist.pageSize
                );
              } else {
                this.$message.error(d.msg);
              }
            });
          // console.log(this.tableSelection[0].enable);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    getchonzi() {
      (this.recType = ""),
        (this.title = ""),
        this.getSendMessageList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxu() {
      this.getSendMessageList(this.searlist.curPage, this.searlist.pageSize);
    },

    getSendMessageList(curr, pagesize) {
      this.$api.activitymsg
        .getSendMessageList({
          current: curr,
          size: pagesize,
          recType: this.recType,
          title: this.title,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getchakxq(id) {
      this.$router.push({
        path: "/messagelist/xiangqing",
        query: {
          id: id,
        },
      });
      // this.$router.push("/messagelist/xiangqing");
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style scoped>
.x {
  height: 20px;
}
</style>
